import './App.css';
import PDFViewer from '../PDFViewer/PDFViewer';
import { signedUrlExtractor } from '../../utils/signedUrlExtractor';

function App() {
  return (
    <div className="App">
      <PDFViewer src={signedUrlExtractor()}/>
    </div>
  );
}

export default App;
